import { render, staticRenderFns } from "./SetCustomerDetails.vue?vue&type=template&id=006692db&scoped=true&"
import script from "./SetCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./SetCustomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006692db",
  null
  
)

export default component.exports